import React, { useState, useEffect, useMemo } from 'react'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import ProfileForm from './ProfileForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { StatusPill, ActionIconButton, ListPageShell, SideDrawer, EmptyState } from '../../Components/Ui'

const Profile = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [localSearch, setLocalSearch] = useState('')
    const [tableFilter, setTableFilter] = useState('')

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.profile.get_profile().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
        }
    }, [reload])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.profile.profile_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
            setReload(true)
        })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idProfile) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idProfile } = $this.dataset

        Controllers.profile.get_profile_id({ p_id_profile: idProfile }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idProfile}`)
            setDataUpdated({ data: res.data })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
        .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleOpenCreate = () => {
        setModalTitle(`Registrar ${nameSingle}`)
        setDataUpdated({})
        setModalShow(true)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.profile.profile_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setReload(true)
            setLoadSubmitDelete(false)
        })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idProfile, nameProfile } = e.currentTarget.dataset
        setDataDeleted({
            p_id_profile: idProfile,
            p_name_profile: nameProfile
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const applySearch = () => setTableFilter(localSearch)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        textFilter={tableFilter}
        hideSearch
        head={[
            [
                { name: 'id_profile', text: 'ID', align: 'center' },
                { name: 'description_profile', text: 'Descripción', align: 'center' },
                { name: 'main_profile', text: 'Principal', align: 'center' },
                { name: 'enabled_profile', text: 'Estado', align: 'center', render: r => <StatusPill tone={parseInt(r.enabled_profile) === 1 ? 'success' : 'danger'}>
                    {parseInt(r.enabled_profile) === 1 ? 'Activo' : 'Inactivo'}
                </StatusPill> },
                { name: 'actions', text: 'Acciones', align: 'center', render: u => {
                    if (parseInt(u.id_profile) === 1 && Helpers.config.isDeveloperWeb()) {
                        return ''
                    }
                    return <div className="sp-row-actions">
                        <ActionIconButton tone="ghost" icon="fa fa-pen" label="Editar" data-id-profile={u.id_profile} onClick={handleGet} />
                        <ActionIconButton tone="danger" icon="fa fa-trash" label="Eliminar" data-id-profile={u.id_profile} data-name-profile={u.name_profile} onClick={handleShowModalDelete} />
                    </div>
                } },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing, tableFilter])

    const showEmpty = !isProcessing && rows.length === 0

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title={`Listado de ${namePlural}`}
            subtitle="Administra los perfiles de acceso y su estado."
            badge="Actividad actualizada"
            primaryAction={
                <ListPageShell.PrimaryButton onClick={handleOpenCreate} icon="fa fa-plus">
                    Registrar {nameSingle}
                </ListPageShell.PrimaryButton>
            }
            onSearch={applySearch}
            filters={[
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Perfil…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            {showEmpty ? (
                <EmptyState
                    icon="fa fa-user-shield"
                    title={`No hay ${namePlural.toLowerCase()} para mostrar`}
                    text="Ajusta la búsqueda o registra un nuevo perfil para empezar."
                    action={
                        <ListPageShell.PrimaryButton onClick={handleOpenCreate}>
                            Registrar {nameSingle}
                        </ListPageShell.PrimaryButton>
                    }
                />
            ) : (
                <div className="sp-table-wrap">{dtRows}</div>
            )}
        </ListPageShell>

        <SideDrawer
            open={modalShow}
            onClose={handleHideModalForm}
            title={modalTitle}
            subtitle="Los cambios se guardan al confirmar el formulario."
        >
            <ProfileForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
        </SideDrawer>

        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_profile} - {dataDeleted.p_name_profile}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default Profile
